import { Injectable } from '@angular/core';
import { CustomItem } from '@domains';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CustomItemService } from '@rspl-api';
import { EMPTY } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as fromActions from './custom-item.actions';

@Injectable()
export class CustomItemEffects {
  getCustomItems = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.getCustomItems),
      switchMap((params) =>
        this.service.filter(params.findParams).pipe(
          map((results) => {
            return fromActions.getCustomItemsSuccess({
              resultsCount: results.totalResults,
              results: results.results.map((p) => new CustomItem(p)),
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  getCustomItem = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.getCustomItem),
      switchMap((params) =>
        this.service.find(params.id, (params.expand?.length || 0) > 0, params.expand).pipe(
          map((result) => {
            return fromActions.getCustomItemSuccess({
              item: new CustomItem(result),
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  createCustomItem = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.createCustomItem),
      switchMap((payload) => {
        return this.service.create(payload.item).pipe(
          map((result) => {
            return fromActions.createCustomItemSuccess({
              item: result,
            });
          }),
          catchError(() => [fromActions.createCustomItemFail()]),
        );
      }),
    );
  });

  updateCustomItem = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.updateCustomItem),
      switchMap((payload) =>
        this.service.update(payload.item.id, payload.item).pipe(
          map((result) => {
            return fromActions.updateCustomItemSuccess({
              item: result,
            });
          }),
          catchError(() => [fromActions.updateCustomItemFail()]),
        ),
      ),
    );
  });

  deleteCustomItem = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.deleteCustomItem),
      switchMap((params) =>
        this.service.delete(params.itemId).pipe(
          map(() => {
            return fromActions.deleteCustomItemSuccess({
              itemId: params.itemId,
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  restoreCustomItem = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.restoreCustomItem),
      switchMap((params) =>
        this.service.restore(params.itemId).pipe(
          map(() => {
            return fromActions.restoreCustomItemSuccess({
              itemId: params.itemId,
            });
          }),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private service: CustomItemService,
  ) {}
}
